import { render, staticRenderFns } from "./ModalDetailPO.vue?vue&type=template&id=6a320ac6&"
import script from "./ModalDetailPO.vue?vue&type=script&lang=js&"
export * from "./ModalDetailPO.vue?vue&type=script&lang=js&"
import style1 from "./ModalDetailPO.vue?vue&type=style&index=1&id=6a320ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports